import React, { useEffect, useRef } from "react"

interface IProps {
    className?: string
    wrapperClassName?: string
    children?: React.ReactNode
    isOpen?: boolean
    Close?: Function
    closeOnOutsideClick?: boolean
    // when true (default), body scroll is locked while modal is open
    lockScroll?: boolean
}

export default function Modal({
    className = "",
    wrapperClassName = "",
    children,
    isOpen = false,
    Close = () => {},
    closeOnOutsideClick = true,
    lockScroll = true,
}: IProps) {
    const modalRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const originalOverflow = document.body.style.overflow
        const disableBodyScroll = (e: TouchEvent) => {
            if (
                modalRef.current &&
                modalRef.current.contains(e.target as Node)
            ) {
                return
            }
            e.preventDefault()
        }

        if (isOpen) {
            if (lockScroll) {
                document.body.style.overflow = "hidden"
                document.body.addEventListener("touchmove", disableBodyScroll, {
                    passive: false,
                })
            } else {
                // allow scrolling while modal open
                document.body.style.overflow = "auto"
            }
        } else {
            document.body.style.overflow = originalOverflow || ""
        }

        return () => {
            document.body.style.overflow = originalOverflow || ""
            document.body.removeEventListener("touchmove", disableBodyScroll)
        }
    }, [isOpen, lockScroll])

    // If modal is not open, return null immediately
    if (!isOpen) {
        return null
    }

    return (
        <div
            key={`modal-${isOpen ? "open" : "closed"}`}
            className={`fixed inset-0 bg-black bg-opacity-50 backdrop-blur-lg flex justify-center items-center z-50 ${
                closeOnOutsideClick ? "cursor-pointer" : "cursor-default"
            } ${wrapperClassName}`}
            onClick={(e) => {
                if (closeOnOutsideClick) {
                    Close(e)
                }
            }}
        >
            <div
                className={"Modal cursor-default overflow-hidden " + className}
                onClick={(e) => e.stopPropagation()}
                ref={modalRef}
            >
                {children}
            </div>
        </div>
    )
}
